window.Minus40Core = class Minus40Core {

    /** @type {Minus40Core} */
    static instance = null;

    static getInstance() {
        if(this.instance !== null) {
            return this.instance;
        }
        this.instance = new Minus40Core();
        return this.instance;
    }

    pageVars = {}
    embeddedJavascriptStates = {};

    constructor() {
        this.parsePageVars();
    }

    parsePageVars(){
        this.pageVars = typeof page_vars !== 'undefined' && page_vars ? page_vars : this.pageVars;
    }

    /**
     *
     * @param value {string}
     * @returns {string}
     */
    trimSlashes(value){
        return value.replace(/^\/+|\/+$/g, '');
    }

    /**
     *
     * @param object {{}}
     * @returns {number}
     */
    keyCount(object)
    {
        return Object.keys(object).length
    }

    /**
     *
     * @param value {any}
     * @param notEmpty {boolean=}
     * @returns {boolean}
     */
    isArray(value, notEmpty)
    {
        return !!value && Array.isArray(value) && (!notEmpty || !!value.length);
    }

    /**
     *
     * @param value {any}
     * @param notEmpty {boolean=}
     * @returns {boolean}
     */
    isObject(value, notEmpty)
    {
        return !!value && typeof value === 'object' && !this.isArray(value) && (!notEmpty || !!this.keyCount(value));
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isAnyNull(value)
    {
        return value === undefined || value === null;
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isNumber(value)
    {
        return !this.isAnyNull(value) && typeof value === 'number';
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isNumeric(value)
    {
        return !this.isAnyNull(value) && !isNaN(value) && value !== "";
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isString(value)
    {
        return !this.isAnyNull(value) && (typeof value === 'string' || value instanceof String)
    }

    /**
     *
     * @param value {any}
     * @returns {boolean}
     */
    isBool(value)
    {
        return value === true || value === false;
    }

    /**
     *
     * @param value {string}
     * @returns {string}
     */
    numericString(value)
    {
        return value.replace(/[^\d.-]/g, '');
    }

    /**
     *
     * @param object {{}}
     * @returns {string|null}
     */
    firstKey (object)
    {
        const keys = Object.keys(object);
        return keys.length ? keys[0] : null;
    }

    /**
     *
     * @param text {string}
     * @returns {string}
     */
    stripHTML (text)
    {
        const div = document.createElement("div");
        div.innerHTML = text;
        return div.textContent || div.innerText || "";
    }


    /**
     *
     * @param value {any}
     * @returns {{}|[]|null}
     */
    validJSON(value) {
        try {
            const obj = value && (typeof value === 'string') ? JSON.parse(value) : null;
            if (obj && ((typeof obj === "object") || Array.isArray(obj))) {
                return obj;
            }
        } catch (e) {

        }
        return null;
    }

    /**
     *
     * @param string {string}
     * @returns {string}
     */
    alphaNumeric(string){
        return string.replace(/[^0-9A-Z]+/gi,"");
    }

    /**
     *
     * @param string1 {string}
     * @param string2 {string}
     * @returns {boolean}
     */
    compareSimilarStrings(string1, string2){
        return this.alphaNumeric(string1).toLowerCase() === this.alphaNumeric(string2).toLowerCase();
    }

    /**
     *
     * @param matchingString {string}
     * @param arrayGroup {{}}
     * @returns {string|null}
     */
    findKeyInArrayGroup(matchingString, arrayGroup){
        for(let key in arrayGroup){
            const array = arrayGroup[key];
            for(let item of array){
                if(this.compareSimilarStrings(item, matchingString)){
                    return key;
                }
            }
        }
        return null;
    }

    /**
     *
     * @param countryName {string}
     * @returns {string}
     */
    normalisedCountryCode(countryName) {

        const arrayGroup = {
            GB: ["United Kingdom", "Great Britain", "Northern Ireland", "UK", "GB", "NI"],
            IE: ["Republic of Ireland", "Ireland", "IE"]
        };
        const name = this.findKeyInArrayGroup(countryName, arrayGroup);
        return name ? name : "";
    }

    /**
     *
     * @param ms {number}
     * @returns {Promise<unknown>}
     */
    sleep(ms)
    {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /**
     *
     * @param src {string}
     * @param callback {(boolean) => void}
     */
    embedJavascript(src, callback){
        const state = this.embeddedJavascriptStates[src] ?? {requested: false, determined: false, success: false, callbacks: []};
        this.embeddedJavascriptStates[src] = state;
        if(state.determined){
            callback(!!state.success);
            return;
        }
        state.callbacks.push(callback);
        if(state.requested){
            return;
        }
        state.requested = true;

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;

        const handleDetermined = () => {
            state.determined = true;
            for(let callback of state.callbacks){
                callback(state.success)
            }
            state.callbacks.length = 0;
        }

        script.onload = () => {
            state.success = true;
            handleDetermined();
        };
        script.onerror = () =>{
            state.success = false;
            handleDetermined();
        };
        document.body.appendChild(script);

    }

}